/* ═══════════════════════════════════════════════════════
   2480 — Theme JS
   ═══════════════════════════════════════════════════════ */

/* ── MENU ────────────────────────────────────────────── */
var _menuScrollY = 0;
function openMenu() {
  document.getElementById('menu-fs').classList.add('open');
  var btn = document.getElementById('menu-btn');
  if (btn) btn.classList.add('is-open');
  /* Verrou scroll iOS-safe : position fixed (rien ne l'écrase, contrairement à overflow) */
  _menuScrollY = window.scrollY || window.pageYOffset || 0;
  document.body.style.position = 'fixed';
  document.body.style.top = (-_menuScrollY) + 'px';
  document.body.style.left = '0';
  document.body.style.right = '0';
  document.body.style.width = '100%';
  document.body.style.overflow = 'hidden';
}
function closeMenu() {
  document.getElementById('menu-fs').classList.remove('open');
  var btn = document.getElementById('menu-btn');
  if (btn) btn.classList.remove('is-open');
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.style.overflow = '';
  window.scrollTo(0, _menuScrollY);
}
document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') closeMenu();
});

/* ── ACCORDION (pages génériques) ──────────────────── */
document.addEventListener('click', function(e) {
  var header = e.target.closest('.accordion-header');
  if (!header) return;
  var isOpen = header.getAttribute('aria-expanded') === 'true';
  var body = header.nextElementSibling;
  if (isOpen) {
    header.setAttribute('aria-expanded', 'false');
    body.hidden = true;
  } else {
    header.setAttribute('aria-expanded', 'true');
    body.hidden = false;
  }
});

/* ── CART COUNT UPDATE ───────────────────────────────── */
function updateCartCount() {
  fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var count = cart.item_count;
      /* Badge nav global */
      var badge = document.getElementById('cart-count');
      if (badge) {
        badge.textContent = count;
        badge.style.display = count > 0 ? 'flex' : 'none';
      }
      /* Badge panier page produit */
      var p2480Badge = document.getElementById('p2480-count');
      if (p2480Badge) p2480Badge.textContent = count;
    });
}

/* ── CART QUANTITY UPDATE (page panier) ──────────────── */
function updateCartItem(key, quantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({ id: key, quantity: quantity })
  })
  .then(function() { window.location.reload(); });
}

/* ── COOKIE BAR ──────────────────────────────────────── */
function p2480CookieChoice(choice) {
  try { localStorage.setItem('2480_cookies', choice); } catch(e) {}
  var bar = document.getElementById('p2480-ck');
  if (bar) { bar.classList.remove('visible'); bar.classList.add('out'); }
}
window.p2480CookieChoice = p2480CookieChoice;

(function() {
  var seen = null;
  try { seen = localStorage.getItem('2480_cookies'); } catch(e) {}
  if (!seen) {
    setTimeout(function() {
      var bar = document.getElementById('p2480-ck');
      if (bar) bar.classList.add('visible');
    }, 1400);
  }
})();

/* ── EMAIL POPUP ─────────────────────────────────────── */
function p2480EmailClose() {
  try { localStorage.setItem('2480_email_seen', '1'); } catch(e) {}
  var ov = document.getElementById('p2480-em-ov');
  if (ov) ov.classList.remove('open');
}
window.p2480EmailClose = p2480EmailClose;

function p2480EmClickOut(e) {
  if (e.target === document.getElementById('p2480-em-ov')) p2480EmailClose();
}
window.p2480EmClickOut = p2480EmClickOut;

function p2480EmailSub() {
  var input = document.getElementById('p2480-em-input');
  if (!input || !input.value || !input.value.includes('@')) {
    if (input) { input.style.borderColor = '#c1341a'; input.focus(); setTimeout(function() { input.style.borderColor = ''; }, 1200); }
    return;
  }
  try { localStorage.setItem('2480_email_seen', '1'); localStorage.setItem('2480_email', input.value); } catch(e) {}
  var form = document.getElementById('p2480-em-form');
  var ok   = document.getElementById('p2480-em-ok');
  if (form) form.style.display = 'none';
  if (ok)   ok.style.display   = 'block';
  setTimeout(p2480EmailClose, 2200);
}
window.p2480EmailSub = p2480EmailSub;

/* ── INTRO SPLASH — 2480 puis Star FM (mobile, 1x/session) ─────────── */
(function(){
  try{
    if(sessionStorage.getItem('intro2480')) return;
    sessionStorage.setItem('intro2480','1');
  }catch(e){ return; }
  var css = document.querySelector('link[href*="/assets/theme.css"]');
  if(!css) return;
  var base = css.getAttribute('href').replace(/theme\.css.*$/, '');
  var L1 = base + 'logo-2480-cup.svg';
  var LC = 'https://cdn.shopify.com/s/files/1/0663/1502/6684/files/logo-cup-2480-turq.png?v=1785412139';
  var L2 = base + 'star-fm-logo.png';
  var st = document.createElement('style');
  st.textContent = '#intro-2480{position:fixed;inset:0;z-index:99999;background:#0c0b0f;transition:opacity .5s ease}#intro-2480.out{opacity:0;pointer-events:none}#intro-2480 img{position:absolute;top:50%;left:50%;opacity:0;transform:translate(-50%,-50%) scale(.94);transition:opacity .18s ease,transform .22s cubic-bezier(.16,1,.3,1)}#intro-2480 .il1{width:52%;max-width:320px}#intro-2480 .ilc{width:60%;max-width:300px}#intro-2480 .il2{width:76%;max-width:460px}#intro-2480.s1 .il1{opacity:1;transform:translate(-50%,-50%) scale(1)}#intro-2480.s2 .il1{opacity:0;transform:translate(-50%,-50%) scale(1.06)}#intro-2480.s2 .ilc{opacity:1;transform:translate(-50%,-50%) scale(1)}#intro-2480.s3 .ilc{opacity:0;transform:translate(-50%,-50%) scale(1.06)}#intro-2480.s3 .il2{opacity:1;transform:translate(-50%,-50%) scale(1)}#intro-2480 .il-skip{position:absolute;bottom:26px;left:50%;transform:translateX(-50%);font-family:Unbounded,sans-serif;font-size:8px;font-weight:900;letter-spacing:.2em;text-transform:uppercase;color:rgba(245,243,239,.32)}';
  document.head.appendChild(st);
  var ov = document.createElement('div'); ov.id = 'intro-2480';
  ov.innerHTML = '<img class="il1" alt=""><img class="ilc" alt=""><img class="il2" alt=""><span class="il-skip">Passer</span>';
  ov.querySelector('.il1').src = L1;
  ov.querySelector('.ilc').src = LC;
  ov.querySelector('.il2').src = L2;
  var root = document.documentElement, ended = false;
  function done(){ if(ended) return; ended = true; ov.classList.add('out'); root.style.overflow=''; document.body.style.overflow=''; setTimeout(function(){ if(ov.parentNode) ov.remove(); }, 520); }
  function mount(){
    document.body.appendChild(ov);
    root.style.overflow='hidden'; document.body.style.overflow='hidden';
    ov.addEventListener('click', done);
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ ov.classList.add('s1'); }); });
    setTimeout(function(){ ov.classList.add('s2'); }, 420);
    setTimeout(function(){ ov.classList.add('s3'); }, 840);
    setTimeout(done, 1360);
  }
  if(document.body){ mount(); } else { document.addEventListener('DOMContentLoaded', mount); }
})();
